const SKIP_PERSON_NAME_PATTERNS: RegExp[] = [
  /^Caller\s+\d/i,
  /^WhatsApp/i,
  /^Instagram/i,
  /^@/,
  /^Lead$/i,
  /^WhatsApp enquiry$/i,
  /^Test Sandeep$/i,
  /^Patient app member$/i,
];

function titleCaseSegment(raw: string): string {
  if (!raw) return raw;
  return raw
    .split(/([''])/)
    .map((part) => {
      if (part === "'" || part === "\u2019") return part;
      if (!part) return part;
      return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
    })
    .join("");
}

function titleCaseToken(token: string): string {
  if (!token) return token;
  return token
    .split("-")
    .map((hyphenPart) =>
      hyphenPart
        .split(".")
        .map(titleCaseSegment)
        .join(".")
    )
    .join("-");
}

export function shouldSkipPersonNameNormalize(name: string): boolean {
  const s = String(name || "").trim();
  if (!s) return true;
  return SKIP_PERSON_NAME_PATTERNS.some((re) => re.test(s));
}

/** First letter of each word capitalized; rest lowercase. */
export function normalizePersonName(raw: unknown): string {
  const collapsed = String(raw ?? "")
    .trim()
    .replace(/\s+/g, " ");
  if (!collapsed) return collapsed;
  if (shouldSkipPersonNameNormalize(collapsed)) return collapsed;
  return collapsed.split(" ").map(titleCaseToken).join(" ");
}

export function normalizePersonNameOptional(raw: unknown): string | null {
  const normalized = normalizePersonName(raw);
  return normalized ? normalized : null;
}
